import React, { useState } from 'react'
import Drawer from '@material-ui/core/Drawer'
import { NAV_LINKS } from '../consts/navLinks'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'

const MenuDrawer = ({ handleScroll, functionsRef, pricesRef }) => {
  const [state, setState] = useState({
    top: false,
  })
  const toggleDrawer = (side, open) => () => {
    setState({ ...state, [side]: open })
  }
  const links = NAV_LINKS
  return (
    <>
      <img
        className="menu"
        style={{ cursor: 'pointer' }}
        src={require('../assets/icons/baseline-menu-24px.svg')}
        alt="icon"
        onClick={toggleDrawer('top', true)}
      />

      <Drawer
        anchor="top"
        open={state.top}
        onClose={toggleDrawer('top', false)}
      >
        <div
          tabIndex={0}
          role="button"
          onClick={toggleDrawer('top', false)}
          onKeyDown={toggleDrawer('top', false)}
        >
          <List>
            {links.map(item => {
              return item.id === '1' ? (
                <ListItem button key={item.id}>
                  <ListItemText>
                    <span
                      onClick={() => {
                        handleScroll(functionsRef)
                      }}
                    >
                      {item.title}
                    </span>
                  </ListItemText>
                </ListItem>
              ) : item.id === '2' ? (
                <ListItem button key={item.id}>
                  <ListItemText>
                    <span
                      onClick={() => {
                        handleScroll(pricesRef)
                      }}
                    >
                      {item.title}
                    </span>
                  </ListItemText>
                </ListItem>
              ) : (
                <ListItem button key={item.id}>
                  <ListItemText>
                    <a href={item.href}>{item.title}</a>
                  </ListItemText>
                </ListItem>
              )
            })}
          </List>
        </div>
      </Drawer>
    </>
  )
}

export default MenuDrawer
